import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { createAlertSettingsAction, modifyAlertSettingsAction } from "../../actions";
import { getNivelList, getClaseList } from "../../selectors";
import {
    TextField,
    Grid,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Typography,
    Checkbox,
    Button,
} from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { AddIcon } from "@icarius-icons";
import { getAppColor } from "@icarius-app/selectors";
import useHandleForm from "./useHandleForm";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";

const gridStyle = { height: 75, padding: "0px 10px" };
const flexStyle = { height: 50, display: "flex", alignItems: "center", cursor: "pointer" };

const SelectorButton = ({ text, onClick }) => {
    const color = useSelector(getAppColor);

    return (
        <Button style={{ margin: 5 }} variant={"outlined"} disableRipple={true} onClick={onClick}>
            <AddIcon htmlColor={color} />
            {text}
        </Button>
    );
};

const Form = (props) => {
    const { data, handleClose, alertType } = props;

    const dispatch = useDispatch();

    const nivelList = useSelector(getNivelList);
    const claseList = useSelector(getClaseList);

    const create = (formData) => {
        dispatch(createAlertSettingsAction(formData, alertType)).then((res) => res?.status === 200 && handleClose());
    };

    const modify = (formData) => {
        dispatch(modifyAlertSettingsAction(formData, alertType)).then((res) => res?.status === 200 && handleClose());
    };

    const openValidationError = () => {
        dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
    };

    const openSelectorValidationError = () => {
        dispatch(
            openSnackbarAction({ msg: getLocalizedString("invalidSelectors"), severity: "error", duration: 10000 })
        );
    };

    const { isCreate, formData, setFormValue, submit } = useHandleForm(
        data,
        alertType,
        create,
        modify,
        openValidationError,
        openSelectorValidationError
    );

    return (
        <Grid container item xs={12} direction="row" style={{ width: "95%", margin: "auto" }}>
            <Grid container item xs={12}>
                {!isCreate && (
                    <Grid container item alignItems="center" xs={12} sm={6} md={2} style={gridStyle}>
                        {" "}
                        {/* Tipo de Alerta o Aviso */}
                        <TextField
                            disabled
                            fullWidth
                            margin={"none"}
                            onChange={(e) => setFormValue(e.target.value, "Tipo de Alerta o Aviso")}
                            value={formData["Tipo de Alerta o Aviso"]}
                            label={getLocalizedString("alertOrNoticeType")}
                            inputProps={{ maxLength: 20 }}
                        />
                    </Grid>
                )}
                <Grid container item alignItems="center" xs={12} sm={6} md={2} style={gridStyle}>
                    {" "}
                    {/* Nivel */}
                    <FormControl style={{ width: "100%" }}>
                        <InputLabel required id={`label-Nivel`}>
                            {getLocalizedString("level")}
                        </InputLabel>
                        <Select
                            value={formData.Nivel}
                            labelId={`label-Nivel`}
                            id={`select-Nivel`}
                            onChange={(e) => setFormValue(e.target.value, "Nivel")}
                            margin={"none"}
                        >
                            {nivelList &&
                                nivelList.map((item) => (
                                    <MenuItem className={"whiteText"} key={item.key} value={item.key}>
                                        {item.value}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} md={isCreate ? 10 : 8} style={gridStyle}>
                    {" "}
                    {/* Nombre */}
                    <TextField
                        required
                        fullWidth
                        margin={"none"}
                        label={getLocalizedString("emailSubjectAndName")}
                        value={formData.Nombre}
                        onChange={(e) => setFormValue(e.target.value, "Nombre")}
                        inputProps={{ maxLength: 254 }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} style={{ padding: "20px 10px" }}>
                    {" "}
                    {/* Texto de la Alerta o Aviso */}
                    <TextFieldMultiline
                        required
                        fullWidth
                        label={getLocalizedString("alertOrNoticeText")}
                        rows={25}
                        margin={"none"}
                        value={formData["Texto de la Alerta o Aviso"]}
                        onChange={(e) => setFormValue(e.target.value, "Texto de la Alerta o Aviso")}
                        inputProps={{ spellCheck: "false" }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                    {" "}
                    {/* Link o Enlace */}
                    <TextField
                        fullWidth
                        margin={"none"}
                        value={formData["Link o Enlace"]}
                        onChange={(e) => setFormValue(e.target.value, "Link o Enlace")}
                        label={getLocalizedString("linkAlt")}
                        inputProps={{ maxLength: 254 }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                    {" "}
                    {/* Direccion en el Mapa */}
                    <TextField
                        fullWidth
                        margin={"none"}
                        label={getLocalizedString("mapAddress")}
                        value={formData["Direccion en el Mapa"]}
                        onChange={(e) => setFormValue(e.target.value, "Direccion en el Mapa")}
                        inputProps={{ maxLength: 254 }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                    {" "}
                    {/* Clase */}
                    <FormControl style={{ width: "100%" }}>
                        <InputLabel required id={`label-Clase`}>
                            {getLocalizedString("class")}
                        </InputLabel>
                        <Select
                            value={formData["Clase de Alerta o Aviso"]}
                            labelId={`label-Clase`}
                            id={`select-Clase`}
                            onChange={(e) => setFormValue(e.target.value, "Clase de Alerta o Aviso")}
                            margin={"none"}
                        >
                            {claseList &&
                                claseList.map((item) => (
                                    <MenuItem className={"whiteText"} key={item.key} value={item.key}>
                                        {item.value}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                    {" "}
                    {/* Origen de Alerta o Aviso */}
                    <TextField
                        disabled
                        fullWidth
                        margin={"none"}
                        value={formData["Origen de Alerta o Aviso"]}
                        label={getLocalizedString("alertOrNoticeOrigin")}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} style={{ padding: "20px 10px" }}>
                    {" "}
                    {/* SQL de ejecución */}
                    <TextFieldMultiline
                        required={alertType === "U"}
                        fullWidth
                        label={getLocalizedString("executionSQL")}
                        rows={25}
                        margin={"none"}
                        value={formData["SQL de ejecución"]}
                        onChange={(e) => setFormValue(e.target.value, "SQL de ejecución")}
                        inputProps={{ spellCheck: "false" }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} style={{ padding: "20px 10px" }}>
                    {" "}
                    {/* SQL destinatarios */}
                    <TextFieldMultiline
                        fullWidth
                        label={getLocalizedString("sqlToGetRecipients")}
                        rows={25}
                        margin={"none"}
                        value={formData["SQL destinatarios"]}
                        onChange={(e) => setFormValue(e.target.value, "SQL destinatarios")}
                        inputProps={{ spellCheck: "false" }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} style={{ padding: "20px 10px" }}>
                    {" "}
                    {/* SQL de visualización */}
                    <TextFieldMultiline
                        fullWidth
                        label={getLocalizedString("viewSql")}
                        rows={25}
                        margin={"none"}
                        value={formData["SQL de visualización"]}
                        onChange={(e) => setFormValue(e.target.value, "SQL de visualización")}
                        inputProps={{ spellCheck: "false" }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} style={{ padding: "0px 10px" }}>
                    {" "}
                    {/* Tipo selector por columna */}
                    <TextField
                        required={formData["SQL de visualización"].length > 0}
                        fullWidth
                        helperText={getLocalizedString("sqlVisualizationColumnTypes")}
                        margin={"none"}
                        value={formData["Tipo selector por columna"]}
                        onChange={(e) => setFormValue(e.target.value, "Tipo selector por columna")}
                        label={getLocalizedString("columnSelectorType")}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} style={{ marginTop: 10, marginBottom: 20 }}>
                    <Grid container item direction="column" sm={12}>
                        <SelectorButton
                            onClick={() =>
                                setFormValue(
                                    `${formData["Tipo selector por columna"]},Lista`,
                                    "Tipo selector por columna"
                                )
                            }
                            text={getLocalizedString("dropdownList")}
                        />
                        <SelectorButton
                            onClick={() =>
                                setFormValue(
                                    `${formData["Tipo selector por columna"]},Fecha`,
                                    "Tipo selector por columna"
                                )
                            }
                            text={getLocalizedString("date")}
                        />
                        <SelectorButton
                            onClick={() =>
                                setFormValue(
                                    `${formData["Tipo selector por columna"]},Alfa`,
                                    "Tipo selector por columna"
                                )
                            }
                            text={getLocalizedString("alphanumeric")}
                        />
                        <SelectorButton
                            onClick={() =>
                                setFormValue(
                                    `${formData["Tipo selector por columna"]},Num`,
                                    "Tipo selector por columna"
                                )
                            }
                            text={getLocalizedString("integerNumeric")}
                        />
                        <SelectorButton
                            onClick={() =>
                                setFormValue(
                                    `${formData["Tipo selector por columna"]},Mon`,
                                    "Tipo selector por columna"
                                )
                            }
                            text={getLocalizedString("numericWithDecimals")}
                        />
                    </Grid>
                </Grid>
                <Typography className="whiteText" style={{ fontSize: 14, marginTop: 20, padding: "0px 10px" }}>
                    {getLocalizedString("howToIncludeSQLDataInMail")}
                </Typography>
                <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "center",
                            position: "relative",
                            top: "10px",
                        }}
                    >
                        <div
                            style={flexStyle}
                            onClick={() => setFormValue(!Boolean(formData["Graba referencia"]), "Graba referencia")}
                        >
                            {" "}
                            {/* Graba referencia */}
                            <Typography className="whiteText" variant="subtitle1" style={{ display: "inline-block" }}>
                                {getLocalizedString("saveReference")}
                            </Typography>
                            <Checkbox checked={formData["Graba referencia"]} />
                        </div>
                    </div>
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                    {" "}
                    {/* Nros columnas referencia */}
                    <TextField
                        required={Boolean(formData["Graba referencia"]) && alertType === "U"}
                        fullWidth
                        margin={"none"}
                        value={formData["Nros columnas referencia"]}
                        onChange={(e) => setFormValue(e.target.value, "Nros columnas referencia")}
                        label={getLocalizedString("referenceColumnNumbers")}
                        inputProps={{ maxLength: 254 }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} style={{ padding: "20px 10px" }}>
                    {" "}
                    {/* Texto para cuerpo del email */}
                    <TextFieldMultiline
                        required={alertType === "U"}
                        fullWidth
                        label={getLocalizedString("alertAndEmailBodyText")}
                        helperText={getLocalizedString("alertBodyTextHelperText")}
                        rows={25}
                        margin={"none"}
                        value={formData["Texto para cuerpo del email"]}
                        onChange={(e) => setFormValue(e.target.value, "Texto para cuerpo del email")}
                        inputProps={{ spellCheck: "false" }}
                    />
                </Grid>
            </Grid>
            <Grid container item xs={12} justify={"flex-end"} alignItems="center" style={{ paddingBottom: 20 }}>
                <ButtonDialogAction isAccept onClick={submit} text={getLocalizedString("save")} />
            </Grid>
        </Grid>
    );
};

export default Form;
